import { StyleSheet } from 'react-native';
import { MATCH_SPORT_ACCENT } from '../../../src/quiz/constants/matchSport.constants';

/** The runtime's own near-black backdrop — the host matches it so letterboxing is invisible. */
const RUNTIME_BG = '#0B0D0E';
const TEXT_DIM = '#9CA3AF';
const TEXT_ON_BRIGHT = '#0F1720';

export const matchSportViewStyles = StyleSheet.create({
  fullscreenContainer: {
    backgroundColor: RUNTIME_BG,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
  },

  // The game document fills the full available body — the runtime scales itself to the viewport.
  canvasWrap: {
    flex: 1,
    overflow: 'hidden',
    backgroundColor: RUNTIME_BG,
  },

  backButton: {
    position: 'absolute',
    top: 8,
    left: 8,
    zIndex: 50,
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backArrow: {
    color: '#F7FAFC',
    fontSize: 20,
    fontWeight: '800',
    marginTop: -2,
  },

  // Overlays cover the game for loading / error.
  overlay: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 14,
    padding: 24,
    backgroundColor: 'rgba(11,13,14,0.85)',
  },
  message: { color: TEXT_DIM, fontSize: 14, fontWeight: '500', textAlign: 'center' },

  retryButton: {
    backgroundColor: MATCH_SPORT_ACCENT,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 28,
  },
  retryText: { color: TEXT_ON_BRIGHT, fontSize: 15, fontWeight: '800' },
  pressedDim: { opacity: 0.7 },

  // Slim bottom banner while the daily coin cap is reached (AC-16 / D-5).
  capBanner: {
    position: 'absolute',
    left: 12,
    right: 12,
    bottom: 12,
    zIndex: 40,
    borderRadius: 10,
    paddingVertical: 8,
    paddingHorizontal: 14,
    backgroundColor: 'rgba(0,0,0,0.72)',
    borderWidth: 1,
    borderColor: 'rgba(201,242,77,0.35)',
  },
  capBannerText: { color: TEXT_DIM, fontSize: 12, fontWeight: '600', textAlign: 'center' },
});
